import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPutParams, HttpAuthPutParamsPayload} from "../../../../core/services/common/HttpRequestBuilder";

const listVehicle = (parameters) => {
    let result = HttpAuthGet(routes.LIST_VEHICLE, parameters);
    return result;
}

const createVehicle = (payload) => {
    let result = HttpAuthPost(routes.CREATE_VEHICLE, payload);
    return result;
}

const getVehicleTypes = () => {
    let parameters = null;
    let result = HttpAuthGet(routes.GET_VEHICLE_TYPES, parameters);

    return result;
}

const getViewVehicle = (parameters) => {
    let result = HttpAuthGet(routes.GET_VIEW_VEHICLE, parameters);
    return result;
}

const getActiveVehicleList = (parameters) => {
    let result = HttpAuthGet(routes.GET_ACTIVE_VEHICLE_LIST, parameters);
    return result;
}

const updateVehicleStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_VEHICLE_STATUS, parameters);
    return result;
}

const updateVehicle = (parameters, payload) => {
    let result = HttpAuthPutParamsPayload(routes.UPDATE_VEHICLE, parameters, payload);
    return result;
}

const getVehicleAccessLogs = (parameters) => {
    let result = HttpAuthGet(routes.GET_VEHICLE_ACCESS_LOGS, parameters);
    return result;
}

const filterVehicle = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_VEHICLE, parameters);
    return result;
}


const VehicleService = {
    listVehicle: listVehicle,
    createVehicle: createVehicle,
    getVehicleTypes: getVehicleTypes,
    getViewVehicle: getViewVehicle,
    getActiveVehicleList: getActiveVehicleList,
    updateVehicleStatus: updateVehicleStatus,
    updateVehicle: updateVehicle,
    getVehicleAccessLogs: getVehicleAccessLogs,
    filterVehicle: filterVehicle,
}

export default VehicleService